import { isForcedProd } from '../modules/utilities.js'
import { reduceAdviseSSE } from '../dataProvider/advise.js'
import { genericOrchestrator } from '../componentsOrchestrator/genericOrchestrator.js'

export const SSEInit = (path, handler, resolveGetAdviseSSE) => {
   let SSEResponseTime
   // Mocks SSE
   if (process.env.NODE_ENV === 'development') {
      if (!isForcedProd()) {
         const { MockEvent, EventSource: EventSourceMock } = require('mocksse')
         EventSource = EventSourceMock
         let mockFile = require('../../mocks/' + getSSEMockFileName())
         new MockEvent(mockFile)
      }
   }

   function shouldCallSSE() {
      return typeof window.dataStoreHP.jwt !== 'undefined' && typeof window.dataStoreHP.requestId !== 'undefined'
   }

   if (shouldCallSSE()) {
      let SSE
      let qs = window.location.search === '' ? '?' : window.location.search + '&'
      qs = qs + 'jwt=' + window.dataStoreHP.jwt + '&requestId=' + window.dataStoreHP.requestId

      if (window.location.hostname.indexOf('boutique.orange.fr') !== -1) {
         SSE = new EventSource('https://www.orange.fr/' + path + qs, { withCredentials: true })
      } else {
         if (process.env.NODE_ENV === 'development') {
            if (!isForcedProd()) {
               SSE = new EventSource('/' + path)
            } else {
               SSE = new EventSource('/' + path + qs)
            }
         } else {
            SSE = new EventSource('/' + path + qs)
         }
      }

      window.dataStoreHP.SSEstatus = 'connected'

      SSEResponseTime = new Date().getTime()

      SSE.addEventListener('renderEvent', (event) => {
         try {
            let data = event.data
            if (process.env.NODE_ENV === 'production') {
               // condition webpack de COMPILATION pas de run coté client
               data = JSON.parse(data)
            } else {
               if (isForcedProd()) {
                  data = JSON.parse(data)
               }
            }

            if (data.id === 'advise' && typeof resolveGetAdviseSSE !== 'undefined') {
               // traitement temporaire pour gérer le retour advise via SSE
               reduceAdviseSSE(data, resolveGetAdviseSSE)
            } else {
               if (handler[data.id] === undefined) {
                  genericOrchestrator(data)
               } else {
                  handler[data.id](data)
               }
            }
         } catch (error) {
            console.error('Catch error: SSE renderEvent', { error: error, event: event })
         }
      })

      // SSE Rendering (client only)
      SSE.addEventListener('error', (event) => {
         console.error('SSE connexion error', event)
      })

      // SSE EndOfTransmission
      SSE.addEventListener('EOT', (event) => {
         let eotEvent = new CustomEvent(`sseEndOfTransmition`, {
            detail: {
               eot: true,
               responseTime: new Date().getTime() - SSEResponseTime,
            },
         })
         document.dispatchEvent(eotEvent)
         window.dataStoreHP.SSEstatus = 'disconnected'

         setTimeout(() => {
            window.prerenderReady = true // pour prerender.io
         }, 10000)

         SSE.close()
      })
   }
}

function getSSEMockFileName() {
   // let pageId = window.dataStoreHP.pageId
   // let isLogged = window.dataStoreHP.isLogged ? '' : '-nl'
   // let fileName = `${pageId}${isLogged}.json`
   return 'n1-tv.json'
}
